import instance from "../axios/axios";

export const getDashboardCounts = async () => {
    try {
        const response = await instance.get(`/api/dashboard/counts`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}


export const getLatestAppointments = async () => {
    try {
        const response = await instance.get(`/api/dashboard/latest-appointments`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const getAppointmentsForCurrentWeek = async () => {
    try {
        const response = await instance.get(`/api/dashboard/weekly-appointments`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}